import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { CategoriaHipoModel } from 'src/app/models/categoria-hipo/CategoriaHipoModel';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ICategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/ICategoriaHipoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CategoriaHipoService } from 'src/app/services/categoria-hipo/categoria-hipo.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  templateUrl: './configuracion-categoria-hipo-registrar.component.html',
  styleUrls: ['./configuracion-categoria-hipo-registrar.component.css']
})
export class ConfiguracionCategoriaHipoRegistrarComponent implements OnInit {
  model: ICategoriaHipoModel = new CategoriaHipoModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private router: Router,
    private gbuService: CategoriaHipoService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.gbuService.submit(this.model).subscribe((data) => {
            this.alertDialogService.open("La categoría fue registrada");
            this.router.navigate(['/configuracion', 'categorias-hipo']);  
          });
        }
      });
    }
  }

}
